import React from "react";
import PropTypes from 'prop-types';
import Vmo404Horizontal from "./Vmo404Horizontal";
import Vmo404Verticle from "./Vmo404Verticle";
const VmoErrorPage = ({ dir, ...props }) => {
  // constrender
  function _renderLayout() {
    switch (dir) {
      case "horizontal":
        return <Vmo404Horizontal {...props} />;
      default:
        return <Vmo404Verticle {...props} />;
    }
  }
  return _renderLayout();
};

export default VmoErrorPage;
VmoErrorPage.propTypes = {
  heading: PropTypes.string.isRequired,
  subheader: PropTypes.string,
  btnLabel: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  dir: PropTypes.oneOf(['vertical', 'horizontal']).isRequired
};

VmoErrorPage.defaultProps = {
  heading: 'Sorry, the page is not found!',
  subheader: 'The page you are looking for does not exist or has been moved.',
  btnLabel: 'Go to Homepage',
  dir: 'vertical',
  onClick: () => {
    window.location.href = '/';
  }
};